import React, { useState } from 'react';
import styled from 'styled-components';

import { usePreFetchTickersOnce } from 'api/queries/tickersQueries';
import ExpandableArrow from 'components/basic/icons/ExpandableArrow';
import { CoinIcon } from 'config/coinIcons/CoinIcon';
import { openMarketsSidebar } from 'reduxState/markets/marketsSidebar';
import { useSelector, staticDispatch } from 'reduxState/store';

const Heading = styled.h2`
  display: flex;
  align-items: center;
  /* margin-right: 8px; */
  padding: 8px 0 8px 4px;
  cursor: pointer;
  font-size: var(--medium2);
  font-weight: normal;
  & > span {
    color: var(--gray4c);
  }
  &:hover {
    background: var(--primary7);
    border-radius: 2px;
  }
`;

// const FavoriteWrapper = styled.div`
//   position: relative;
//   top: 2px;
//   padding-left: 5px;
//   padding-right: 5px;
// `;

function MarketHeaderTitle() {
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const isOpened = useSelector(state => state.markets.marketsSidebar.isOpened);

  const [hovered, setHovered] = useState(false);

  usePreFetchTickersOnce(hovered);

  const { base, quote } = currentMarket;

  // const favouriteMarkets = useSelector(
  //   state => state.userSettings.favoriteMarkets
  // );
  // const favouriteIcon = (
  //   <ToggleIcon
  //     onToggle={() => {
  //       if (currentMarket.pair) {
  //         dispatch(toggleFavoriteMarket(activeChain, currentMarket.pair));
  //       }
  //     }}
  //     active={
  //       currentMarket.pair
  //         ? !!isFavoriteMarket(
  //             favouriteMarkets,
  //             activeChain,
  //             currentMarket.pair
  //           )
  //         : false
  //     }
  //     icon="favourite"
  //   />
  // );
  // <>
  //     {base}-{quote} <FavoriteWrapper>{favouriteIcon}</FavoriteWrapper>
  // </>

  return (
    <Heading
      onClick={() => staticDispatch(openMarketsSidebar())}
      onMouseOver={hovered ? undefined : () => setHovered(true)}
    >
      {base && <CoinIcon symbol={base} size="16px" />}&nbsp; {base}
      <span>-{quote}</span>
      <ExpandableArrow expanded={isOpened} />
    </Heading>
  );
}

export default MarketHeaderTitle;
